export default function deleteServerModuleReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'DELETE_SERVER_MODULE_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'DELETE_SERVER_MODULE_ERROR':
            return {...state, ...{ error: action.error }};

        case 'DELETE_SERVER_MODULE_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}